export default "__VITE_ASSET__DMYuwmhv__"